// extracted by mini-css-extract-plugin
module.exports = {"startupGaining":"StartupGaining_startupGaining__25Ky4","cards":"StartupGaining_cards__1H58E","card":"StartupGaining_card__2BYXT","btn":"StartupGaining_btn__3h0aN"};